import React, { useEffect, useRef } from 'react'
import { Textarea } from '@/Components/ui/textarea'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/Components/ui/table'
import NoDataFound from '@/Components/Common/NoDataFound'
import SearchableDropdown from '@/Components/Common/SearchableDropdown'
import MultipleSelector from '@/Components/Common/MultipleSelector'
import DatePicker from '@/Components/Common/DatePicker'
import { Input } from '@/Components/ui/input'
import CustomFields from '@/Components/Common/CustomFields'
import ResizingTextArea from '@/Components/Common/ResizingTextArea'
import { object } from 'zod'

const Oasis = ({ form, event, updateEvent, workAllocation }) => {
    const groupSection = workAllocation.mitem.reduce((acc, item) => {
        if (!acc[item.section]) acc[item.section] = []
        acc[item.section].push(item)
        return acc
    }, {})
    let serial = 1
    const textareaRef = useRef(null)
    const heightLimit = 50 // in px

    const handleInput = () => {
        const textarea = textareaRef.current
        if (textarea) {
            textarea.style.height = 'auto' // Reset height to calculate scrollHeight properly

            textarea.style.height = Math.min(textarea.scrollHeight, heightLimit) + 'px'
        }
    }
    useEffect(() => {
        handleInput()
    }, [])
    const picklist = 'SinglePickList'

    return (
        <div className="relative z-50 mt-4  w-max bg-white">
            <Table className="w-max">
                <TableHeader className="bg-purple-100 sticky top-[-1px] z-30">
                    <TableHead className="text-purple-950 font-semibold text-[12px] border border-gray-200 w-max">Sr. No</TableHead>
                    <TableHead className="text-purple-950 font-semibold text-[12px] border border-gray-200 w-[200px]">OASIS Items</TableHead>
                    <TableHead className="text-purple-950 font-semibold text-[12px] border border-gray-200 w-[300px] ">Questions</TableHead>
                    <TableHead className="text-purple-950 font-semibold text-[12px] border border-gray-200 w-[200px] ">
                        Clinician Response(coder)
                    </TableHead>
                    <TableHead className="text-purple-950 font-semibold text-[12px] border border-gray-200 w-[200px]">Coder Response</TableHead>
                    <TableHead className="text-purple-950 font-semibold text-[12px] border border-gray-200 w-[200px] ">Reason for change </TableHead>
                    <TableHead className="text-purple-950 font-semibold text-[12px] border border-gray-200 w-[200px] ">
                        Clinician Response (QA)
                    </TableHead>
                    <TableHead className="text-purple-950 font-semibold text-[12px] border border-gray-200 w-[200px] ">QA Response</TableHead>
                    <TableHead className="text-purple-950 font-semibold text-[12px] border border-gray-200  w-[400px]">QA Rationale </TableHead>
                </TableHeader>

                <TableBody className={`overflow-auto ${workAllocation.mitem.length > 8 && 'h-[calc(100vh-280px)]'} overflow-card-scroll z-5`}>
                    {Object.entries(groupSection).map(([section, items], sectionIndex) => (
                        <React.Fragment key={sectionIndex}>
                            <TableRow className="h-0">
                                <TableCell colspan={9} className="bg-gray-200  h-8 text-left font-semibold">
                                    {section}
                                </TableCell>
                            </TableRow>
                            {items.map((item, index) => {
                                const currentSerial = serial++
                                return (
                                    <TableRow key={index} className="h-1">
                                        <TableCell className="border border-gray-200">{currentSerial}</TableCell>
                                        <TableCell className="border border-gray-200"> {item.name}</TableCell>
                                        <TableCell className="border border-gray-200"> {item.questions}</TableCell>
                                        <TableCell className="border border-gray-200 px-0 py-0">
                                            <CustomFields
                                                type={item.picklist}
                                                label="response"
                                                options={item.response}
                                                value={item.clinician_response}
                                                handleOnChange={(val) => {
                                                    let changedmitem = {}

                                                    const updatedMitem = event.work_allocation.mitem.map((m) => {
                                                        if (m.name === item.name) {
                                                            changedmitem = {
                                                                ...m,
                                                                mitems: m.name,
                                                                clinician_response: val,
                                                            }
                                                        }
                                                        return m.name === item.name ? { ...m, clinician_response: val } : m
                                                    })

                                                    updateEvent({
                                                        work_allocation: {
                                                            ...event.work_allocation,
                                                            mitem: updatedMitem,
                                                        },
                                                        update_obj: {
                                                            name: event.work_allocation.name,
                                                            data: {
                                                                mitem_table: [{ ...changedmitem }],
                                                            },
                                                        },
                                                    })
                                                }}
                                                className="border border-none shadow-none"
                                            />
                                        </TableCell>
                                        <TableCell className="border border-gray-200  px-0 py-0">
                                            <CustomFields
                                                type={item.picklist}
                                                label="response"
                                                options={item.response}
                                                value={item.redroad_coder_response}
                                                handleOnChange={(val) => {
                                                    let changedmitem = {}
                                                    const updatedMitem = event.work_allocation.mitem.map((m) => {
                                                        if (m.name === item.name) {
                                                            changedmitem = {
                                                                ...m,
                                                                mitems: m.name,
                                                                redroad_coder_response: val,
                                                            }
                                                        }
                                                        return m.name === item.name ? { ...m, redroad_coder_response: val } : m
                                                    })

                                                    updateEvent({
                                                        work_allocation: {
                                                            ...event.work_allocation,
                                                            mitem: updatedMitem,
                                                        },
                                                        update_obj: {
                                                            name: event.work_allocation.name,
                                                            data: {
                                                                mitem_table: [{ ...changedmitem }],
                                                            },
                                                        },
                                                    })
                                                }}
                                                className="border border-none shadow-none"
                                            />
                                        </TableCell>

                                        <TableCell className="border border-gray-200  px-0 py-0">
                                            <ResizingTextArea
                                                value={item.reason_for_change && item.reason_for_change}
                                                handleOnChange={(val) => {
                                                    let changedmitem = {}
                                                    const updatedMitem = event.work_allocation.mitem.map((m) => {
                                                        if (m.name === item.name) {
                                                            changedmitem = {
                                                                ...m,
                                                                mitems: m.name,
                                                                reason_for_change: val,
                                                            }
                                                        }
                                                        return m.name === item.name ? { ...m, reason_for_change: val } : m
                                                    })

                                                    updateEvent({
                                                        work_allocation: {
                                                            ...event.work_allocation,
                                                            mitem: updatedMitem,
                                                        },
                                                        update_obj: {
                                                            name: event.work_allocation.name,
                                                            data: {
                                                                mitem_table: [{ ...changedmitem }],
                                                            },
                                                        },
                                                    })
                                                }}
                                                className="border border-none shadow-none"
                                            />
                                        </TableCell>
                                        <TableCell className="border border-gray-200  px-0 py-0">
                                            <CustomFields
                                                type={item.picklist}
                                                label="response"
                                                options={item.response}
                                                value={item.clinician_response_qa}
                                                handleOnChange={(val) => {
                                                    let changedmitem = {}
                                                    const updatedMitem = event.work_allocation.mitem.map((m) => {
                                                        if (m.name === item.name) {
                                                            changedmitem = {
                                                                ...m,
                                                                mitems: m.name,
                                                                clinician_response_qa: val,
                                                            }
                                                        }
                                                        return m.name === item.name ? { ...m, clinician_response_qa: val } : m
                                                    })

                                                    updateEvent({
                                                        work_allocation: {
                                                            ...event.work_allocation,
                                                            mitem: updatedMitem,
                                                        },
                                                        update_obj: {
                                                            name: event.work_allocation.name,
                                                            data: {
                                                                mitem_table: [{ ...changedmitem }],
                                                            },
                                                        },
                                                    })
                                                }}
                                                className="border border-none shadow-none"
                                            />
                                        </TableCell>
                                        <TableCell className="border border-gray-200  px-0 py-0">
                                            <CustomFields
                                                type={item.picklist}
                                                label="response"
                                                options={item.response}
                                                value={item.redroad_qa_response}
                                                handleOnChange={(val) => {
                                                    let changedmitem = {}
                                                    const updatedMitem = event.work_allocation.mitem.map((m) => {
                                                        if (m.name === item.name) {
                                                            changedmitem = {
                                                                ...m,
                                                                mitems: m.name,
                                                                redroad_qa_response: val,
                                                            }
                                                        }
                                                        return m.name === item.name ? { ...m, redroad_qa_response: val } : m
                                                    })

                                                    updateEvent({
                                                        work_allocation: {
                                                            ...event.work_allocation,
                                                            mitem: updatedMitem,
                                                        },
                                                        update_obj: {
                                                            name: event.work_allocation.name,
                                                            data: {
                                                                mitem_table: [{ ...changedmitem }],
                                                            },
                                                        },
                                                    })
                                                }}
                                                className="border border-none shadow-none"
                                            />
                                        </TableCell>
                                        <TableCell className="border border-gray-200  px-0 py-0">
                                            <ResizingTextArea
                                                label="response"
                                                options={item.response}
                                                value={item.qa_resason_for_change}
                                                handleOnChange={(val) => {
                                                    let changedmitem = {}
                                                    const updatedMitem = event.work_allocation.mitem.map((m) => {
                                                        if (m.name === item.name) {
                                                            changedmitem = {
                                                                ...m,
                                                                mitems: m.name,
                                                                qa_resason_for_change: val,
                                                            }
                                                        }
                                                        return m.name === item.name ? { ...m, qa_resason_for_change: val } : m
                                                    })

                                                    updateEvent({
                                                        work_allocation: {
                                                            ...event.work_allocation,
                                                            mitem: updatedMitem,
                                                        },
                                                        update_obj: {
                                                            name: event.work_allocation.name,
                                                            data: {
                                                                mitem_table: [{ ...changedmitem }],
                                                            },
                                                        },
                                                    })
                                                }}
                                                className="border border-none shadow-none"
                                            />
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </React.Fragment>
                    ))}
                </TableBody>
            </Table>
        </div>
    )
}

export default Oasis
